import React from "react";
import img from "../../assets/rangamati.jpg";

const Articales = () => {
  return (
    <div className="p-5 mx-auto sm:p-10 md:p-16">
      <div className="flex flex-col max-w-3xl mx-auto overflow-hidden rounded">
        <img src={img} alt="" className="w-full h-60 sm:h-96" />
        <div className="p-6 pb-12 m-4 mx-auto -mt-16 space-y-6 lg:max-w-2xl sm:px-10 sm:mx-12 lg:rounded-md bg-slate-500 text-white">
          <div className="space-y-2">
            <p
              className="inline-block text-2xl font-semibold sm:text-3xl"
            >
              Rangamati the place you must visit
            </p>
          </div>
          <div className="">
            <p>In the rainy season rangamati express her actual beautiness. <br />
                a cup of tea with your better half</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Articales;
